import React, { useEffect } from 'react'
import 'firebase/compat/analytics'
import PropTypes from 'prop-types'

import { residential } from 'modals/variables'
import { BudgetStep } from 'modals/components/steps/BudgetStep/BudgetStep'
import { LocationsStep } from 'modals/components/steps/LocationsStep/LocationsStep'
import { MainModal } from 'modals/components/parts/MainModal/MainModal'
import { MainModalBody } from 'modals/components/parts/MainModalBody/MainModalBody'
import { MainModalIndicator } from 'modals/components/parts/MainModalIndicator/MainModalIndicator'
import { RolesStep } from 'modals/components/steps/RolesStep/RolesStep'
import { TypesStep } from 'modals/components/steps/TypesStep/TypesStep'
import { TypesAdditionalStep } from 'modals/components/steps/TypesAdditionalStep/TypesAdditionalStep'
import { ExperienceStep } from 'modals/components/steps/ExperienceStep/ExperienceStep'
import { SkillsStep } from 'modals/components/steps/SkillsStep/SkillsStep'
import { ImageStep } from 'modals/components/steps/ImageStep/ImageStep'
import { DescriptionStep } from 'modals/components/steps/DescriptionStep/DescriptionStep'
import { MainModalFooter } from 'modals/components/parts/MainModalFooter/MainModalFooter'
import { MainModalHeader } from 'modals/components/parts/MainModalHeader/MainModalHeader'
import { MainModalLastScreen } from 'modals/components/parts/MainModalLastScreen/MainModalLastScreen'

export const ProfileModal = ({
  isOpened,
  title,
  subtitle,
  steps,
  currentTab,
  role,
  types,
  investmentTypes,
  propertyTypes,
  investmentLocation,
  userLocation,
  experience,
  skills,
  image,
  description,
  budget,

  onSkip,
  onChangeTab,
  onChangeRole,
  onChangeTypes,
  onChangePropertyTypes,
  onChangeInvestmentTypes,
  onChangeUserLocation,
  onChangeInvestmentLocation,
  onChangeExperience,
  onChangeImage,
  onChangeDescription,
  onChangeSkills,
  onChangeBudget,
}) => {
  const isResidential = types.includes(residential)

  useEffect(() => {
    onBlur(isOpened);

    if(!isOpened){
      onChangeTab(0)
    }
  }, [isOpened])

  // Functions
  const onPrev = () => {
    if(currentTab === 3 && !isResidential) {
      onChangeTab(currentTab - 2)
      return;
    }
    onChangeTab(currentTab - 1)
  }

  const onNext = () => {
    if(currentTab === 1 && !isResidential) {
      onChangeTab(currentTab + 2)
      return
    }
    onChangeTab(currentTab + 1)
  }

  const onBlur = (opened) => {
    if (opened) {
      document.body.classList.add("onboarding-modal-open");
    } else {
      document.body.classList.remove("onboarding-modal-open");
    }
  }

  return (
    <MainModal isOpened={isOpened}>
      <MainModalHeader title={title} subtitle={subtitle} />

      <MainModalBody>
        <MainModalIndicator allSteps={steps} currentStep={currentTab} />

        <RolesStep
          currentTab={currentTab}
          active={role}
          onChange={onChangeRole}
        />

        <TypesStep
          currentTab={currentTab}
          active={types}
          onChange={onChangeTypes}
        />

        <TypesAdditionalStep
          currentTab={currentTab}
          activeInvestment={investmentTypes}
          activeProperty={propertyTypes}
          onChangePropertyTypes={onChangePropertyTypes}
          onChangeInvestmentTypes={onChangeInvestmentTypes}
        />

        <LocationsStep
          currentTab={currentTab}
          questionNumber={isResidential ? '4' : '3'}
          investmentLocation={investmentLocation}
          userLocation={userLocation}
          onChangeUserLocation={onChangeUserLocation}
          onChangeInvestmentLocation={onChangeInvestmentLocation}
        />

        <BudgetStep
          currentTab={currentTab}
          questionNumber={isResidential ? '5' : '4'}
          active={budget}
          onChange={onChangeBudget}
        />

        <ExperienceStep
          currentTab={currentTab}
          questionNumber={isResidential ? '6' : '5'}
          active={experience}
          onChange={onChangeExperience}
        />

        <SkillsStep
          currentTab={currentTab}
          questionNumber={isResidential ? '7' : '6'}
          active={skills}
          onChange={onChangeSkills}
        />

        <ImageStep
          currentTab={currentTab}
          questionNumber={isResidential ? '8' : '7'}
          src={image}
          onChange={onChangeImage}
        />

        <DescriptionStep
          currentTab={currentTab}
          questionNumber={isResidential ? '9' : '8'}
          value={description}
          onChange={onChangeDescription}
        />

        {currentTab !== steps && (
          <MainModalFooter
            enabledSkipButton={true}
            enabledPrevButton={currentTab !== 0}
            onSkipClick={onSkip}
            onPrevClick={onPrev}
            onNextClick={onNext}
          />
        )}

        {currentTab === steps && (
          <MainModalLastScreen />
        )}
      </MainModalBody>
    </MainModal>
  )
}

ProfileModal.propTypes = {
  isOpened: PropTypes.bool,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  steps: PropTypes.number,
  currentTab: PropTypes.number,
  role: PropTypes.string,
  types: PropTypes.array,
  investmentTypes: PropTypes.array,
  propertyTypes: PropTypes.array,
  investmentLocation: PropTypes.array,
  userLocation: PropTypes.oneOfType([
    PropTypes.object, PropTypes.string,
  ]),
  experience: PropTypes.string,
  skills: PropTypes.array,
  image: PropTypes.string,
  description: PropTypes.string,
  budget: PropTypes.object,

  onChangeRole: PropTypes.func,
  onChangeTypes: PropTypes.func,
  onChangePropertyTypes: PropTypes.func,
  onChangeInvestmentTypes: PropTypes.func,
  onChangeUserLocation: PropTypes.func,
  onChangeInvestmentLocation: PropTypes.func,
  onChangeExperience: PropTypes.func,
  onChangeSkills: PropTypes.func,
  onChangeImage: PropTypes.func,
  onChangeDescription: PropTypes.func,
  onSkip: PropTypes.func,
  onChangeTab: PropTypes.func,
  onChangeBudget: PropTypes.func,
}
